var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:'cardTab'},[_c('div',{staticClass:"center"},[_c('h4',[_c('fs1-span',[_vm._v("No se encontro la pagina buscada...")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }